import { render, staticRenderFns } from "./AirbrakeDefectsSettings.vue?vue&type=template&id=7fc021ea&lang=pug&"
import script from "./AirbrakeDefectsSettings.vue?vue&type=script&lang=js&"
export * from "./AirbrakeDefectsSettings.vue?vue&type=script&lang=js&"
import style0 from "./AirbrakeDefectsSettings.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports